// 数据规范
import {
  getComboOutput,
  getSerialOutput,
  getCascaderSpecsOutput,
  getSelectorSpecsOutput,
  getSystemVariables
} from '@/api/dataSpec.js'
import alasql from 'alasql'
import extendFunctions from '@/views/Report/ReportEditor/js/extend'
import formatConverter from '@/views/Report/ReportEditor/js/formatConverter.js'
export default {
  inject: [
    'dataSheets',
    'id2DataSheets',
    'id2Info',
    'specification',
    'specCache',
    'GetParamWithFieldId',
    'GetDataSheetUsedRowInfo',
    'InsertData2ExtendTable',
    'InsertMasterFieldValue',
    'field'
  ],
  computed: {
    dataSheetsList() {
      return this.dataSheets()
    },
    id2DataSheetsList() {
      return this.id2DataSheets()
    },
    selectValue() {
      return this.currentDataSpec[0] && this.currentDataSpec[0].values ? this.currentDataSpec[0].values : []
    },
    id2InfoList() {
      return this.id2Info()
    },
    specificationList() {
      return this.specification()
    },
    // 缓存数据
    specCacheData() {
      return this.specCache()
    },
    // 数据规范
    // 当前数据规范信息
    currentDataSpec() {
      const map = {
        1: 'DropDown',
        2: 'Cascader',
        3: 'ListView',
        7: 'Selector'
      }
      const currentList = this.specificationList[map[this.item.specType]]
      return currentList ? currentList.filter(c => c.fieldId === this.item.id) : []
    }
  },
  data() {
    return {
      // 列表
      listViewInfo: {},
      listViewVisiable: false,
      showCascader: false,
      cascaderOutput: [],
      arrayData: [], // 单选 多选
      comboData: [], // 下拉数据
      cascaderData: [],
      cascaderProps: { // 级联懒加载
        lazy: true,
        checkStrictly: true,
        leaf: 'lastLevel',
        lazyLoad: async(node, resolve) => {
          const { level } = node
          if (level === 0) {
            if (this.cascaderData && this.cascaderData.length === 1 && this.cascaderData[0].temp) {
              this.cascaderData = []
            }
            if (this.cascaderData.length === 0) {
              await this.initCascaderData(this.item.id)
            }
            resolve(this.cascaderData)
          } else {
            const arr = []
            this.handleTreeArr(node, arr)
            console.log(arr)
            const data = this.handleCascaderData(this.item.id, arr)
            resolve(data)
          }
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    // 列表规范清空数据
    WriteListCleanFillRange(listViewInfo, effectRangeJson) {
      this.listViewVisiable = false
      console.time('列表规范清空数据')
      const mappingInfo = extendFunctions.deepCopy(listViewInfo.mapping)
      const dataTableInfo = this.dataSheetsList[this.id2DataSheetsList[listViewInfo.fieldId]]
      this.CleanMappingRange(mappingInfo, dataTableInfo, effectRangeJson)
      console.timeEnd('列表规范清空数据')
    },
    // 列表规范回写数据
    WriteListSpecSelectedData(fieldId, selectedData, listViewInfo) {
      this.listViewVisiable = false
      var tempValue, columnId
      if (selectedData.length > 0) {
        if (listViewInfo.resultOneRow) {
          var mergedData = [{}]
          for (columnId in selectedData[0]) {
            if (columnId === 'select') {
              continue
            }
            tempValue = ''
            selectedData.forEach(dataRow => {
              if (!dataRow[columnId]) {
                return
              }
              if (dataRow[columnId].toString().indexOf('{"data":') === 0) {
                if (tempValue) {
                  try {
                    var obj = JSON.parse(tempValue)
                    JSON.parse(dataRow[columnId]).data.forEach(item => {
                      obj.data.push(item)
                    })
                    tempValue = JSON.stringify(obj) + ' '
                  } catch (exception) {
                    tempValue = '{data:[]} '
                  }
                } else {
                  tempValue = dataRow[columnId] + ' '
                }
              } else {
                tempValue += dataRow[columnId] + ','
              }
            })
            mergedData[0][columnId] = tempValue.substring(0, tempValue.length - 1)
          }
          selectedData = mergedData
        }
        console.time('列表规范写入数据')
        const mappingInfo = listViewInfo.mapping
        const dataTableInfo = this.dataSheetsList[this.id2DataSheetsList[fieldId]]
        this.connectInsert(dataTableInfo, mappingInfo, selectedData, listViewInfo.rowIndex, true)
        console.timeEnd('列表规范写入数据')
      }
    },
    connectInsert(dataTableInfo, mappingInfo, selectedData, rowIndex, addNewLine) {
      var i, insertRows, usedRowInfo, fieldId, dataRowCount
      var insertData = []
      switch (dataTableInfo.type) {
        case 0:
          // 主表形式
          insertData.push({})
          for (fieldId in mappingInfo) {
            // 整理需要写入的主表字段
            insertData[0][fieldId] = selectedData[0][mappingInfo[fieldId]]
          }
          this.InsertMasterFieldValue(insertData)
          break
        case 1:
          // 检查空白行是否够用
          // 整理需要插入的内容
          for (fieldId in mappingInfo) {
            for (i = 0; i < selectedData.length; i++) {
              if (!insertData[i]) {
                insertData.push({})
              }
              insertData[i][fieldId] = selectedData[i][mappingInfo[fieldId]]
            }
          }
          insertRows = 0
          dataRowCount = insertData.length
          usedRowInfo = this.GetDataSheetUsedRowInfo(dataTableInfo.id)
          insertRows = dataRowCount - usedRowInfo.unUsedCount
          if (insertRows === 0 && addNewLine) {
            insertRows++
          }
          insertRows--
          if (insertRows > 0) {
            for (i = 0; i < insertRows; i++) {
              this.field()[dataTableInfo.id].splice(this.rowIndex, 0, {})
            }
          }
          // 开始执行插入
          console.time('插入查询结果')
          this.InsertData2ExtendTable(dataTableInfo.id, insertData, this.rowIndex)
          console.timeEnd('插入查询结果')
          break
        default:
          extendFunctions.errorMessage(this.$t('report.dataSheetType') + dataTableInfo.type + this.$t('report.notExist'))
          break
      }
    },
    CleanMappingRange(mappingInfo, dataTableInfo, effectRangeJson) {
      var targetFieldId
      var insertData = [{}]
      switch (dataTableInfo.type) {
        case 0:
          // 主表形式
          var insertJson = {}
          for (targetFieldId in mappingInfo) {
            // 整理需要写入的主表字段
            insertJson[targetFieldId] = null
          }
          this.InsertMasterFieldValue([insertJson])
          break
        case 1:
          // 扩展表
          // 检查空白行是否够用
          // 整理需要插入的内容
          for (targetFieldId in mappingInfo) {
            insertData[0][targetFieldId] = null
          }
          // 开始执行插入
          console.time('插入查询结果')
          this.InsertData2ExtendTable(dataTableInfo.id, insertData, this.rowIndex)
          console.timeEnd('插入查询结果')
          break
        default:
          extendFunctions.errorMessage(this.$t('report.dataSheetType') + dataTableInfo.type + this.$t('report.notExist'))
          break
      }
    },
    // 判断使用哪个列表规范
    SelectCurrentListView(listViewInfos, activeCell) {
      var paramArray, params, query
      for (var i = 0; i < listViewInfos.length; i++) {
        query = ''
        params = []
        for (var tableId in listViewInfos[i].conditionParam) {
          if (!query) {
            query = 'SELECT 1 FROM '
          }
          if (+tableId === listViewInfos[i].dataSheetId || this.dataSheetsList[tableId].type === 0) {
            paramArray = []
            listViewInfos[i].conditionParam[tableId].forEach(fieldId => {
              paramArray.push(fieldId)
            })
            params.push([this.GetParamWithFieldId(paramArray, activeCell)])
            query += `? [${tableId}], `
          } else {
            extendFunctions.errorMessage(this.$t('report.otherTable'))
            return Error('暂不支持取其他扩展表值！')
          }
        }
        if (params.length) {
          query = query.substring(0, query.length - 2)
        } else {
          query = 'SELECT 1 '
        }
        if (listViewInfos[i].condition) {
          query += ' WHERE ' + listViewInfos[i].condition
        }
        // 根据计算结果进行扩展收缩处理
        var result = params.length ? alasql(query, params) : alasql(query)
        if (result.length) {
          return extendFunctions.deepCopy(listViewInfos[i])
        }
      }
      return null
    },
    listViewShow() {
      const listViewInfos = this.currentDataSpec
      const fieldId = this.item.id
      const rowData = this.formData
      if (fieldId === undefined) {
        extendFunctions.errorMessage(this.$t('report.listError'))
        return
      }
      this.listViewInfo = this.SelectCurrentListView(listViewInfos, rowData)
      if (this.listViewInfo instanceof Error) {
        return
      }
      if (!this.listViewInfo) {
        var message = ''
        listViewInfos.forEach(info => {
          if (!message) {
            message = info.failtext
          }
        })
        extendFunctions.errorMessage(message || this.$t('report.noListAvailable'))
        return
      }
      // 获取本单据的参数内容
      this.listViewInfo.params = this.GetParamWithFieldId(this.listViewInfo.params, rowData)
      // 获取本单据的唯一列信息
      var unique = this.GetParamWithFieldId(this.listViewInfo.unique)
      var uniqueArray = []
      for (var tempFieldId in unique) {
        if (unique[tempFieldId] && (typeof unique[tempFieldId] === 'object')) {
          unique[tempFieldId].forEach((fieldValue, index) => {
            if (!uniqueArray[index]) {
              uniqueArray.push({})
            }
            uniqueArray[index][tempFieldId] = fieldValue[tempFieldId]
          })
        }
      }
      this.listViewInfo.unique = uniqueArray
      this.listViewInfo.fieldId = fieldId
      this.listViewInfo.rowData = rowData
      this.listViewVisiable = true
      this.$nextTick(function() {
        this.$refs.listViewDataTable.queryStr = ''
        this.$refs.listViewDataTable.selectionTableData = []
        this.$refs.listViewDataTable.GetListViewData()
      })
    },
    // 级联数组数组动态赋值
    handleTreeArr(node, arr) {
      arr.unshift({ value: node.value, label: node.label })
      if (node.parent) {
        this.handleTreeArr(node.parent, arr)
      }
    },
    init() {
      this.showCascader = false
      this.arrayData = [] // 单选 多选
      this.comboData = [] // 下拉数据
      this.cascaderData = []
      this.$nextTick(() => {
        this.showCascader = true
        // 初始化高级复选框
        if (this.fromType === 0) return
        this.handleGetArrayData()
      })
    },
    // 单选 多选
    async handleGetArrayData() {
      if ((this.item.specType === 7) && this.currentDataSpec) {
        this.currentDataSpec.forEach(async(cds) => {
          if (cds.source && cds.source === 1) {
            let output = (await getSelectorSpecsOutput(cds.specId, cds.fieldId)).data
            output = output.filter(o => o !== '')
            cds.values = output
          }
        })
      }
    },
    async handleGetData() {
      if (this.item.specType === 1) {
        console.log('handleGetData')
        if (this.selectValue.length === 0) {
          await this.GetComboOutput()
        }
      }
    },
    // 下拉
    async GetComboOutput() {
      const dropDownInfo = this.currentDataSpec[0]
      var cache = this.specCacheData.DropDown
      var cacheable = dropDownInfo.cache
      var params = this.GetParamWithFieldId(dropDownInfo.params, this.form)
      if (cacheable) {
        if (cache[dropDownInfo.specId]) {
          console.time('查找缓存')
          var cacheValue = cache[dropDownInfo.specId].find(item => item.params === JSON.stringify(params))
          if (cacheValue) {
            console.timeEnd('查找缓存')
            dropDownInfo.values = cacheValue.value
          }
        } else {
          cache[dropDownInfo.specId] = []
        }
      }
      var output = await getComboOutput(dropDownInfo.specId, params, dropDownInfo.fieldId)
      if (output.status >= 200 && output.status < 300) {
        if (this.id2InfoList[dropDownInfo.fieldId].baseType === 4) {
          var data = []
          output.data.forEach(singleDate => {
            switch (this.id2InfoList[dropDownInfo.fieldId].dataType) {
              case 401:
                // 2019
                data.push(formatConverter.ConvertDateTime('yyyy', new Date(singleDate)))
                break
              case 402:
                // 2019年
                data.push(formatConverter.ConvertDateTime('yyyy年', new Date(singleDate)))
                break
              case 403:
                // 2019-1
                data.push(formatConverter.ConvertDateTime('yyyy-M', new Date(singleDate)))
                break
              case 404:
                // 2019/1
                data.push(formatConverter.ConvertDateTime('yyyy/M', new Date(singleDate)))
                break
              case 405:
                // 2019年1月
                data.push(formatConverter.ConvertDateTime('yyyy年M月', new Date(singleDate)))
                break
              case 412:
                // 1月
                data.push(formatConverter.ConvertDateTime('M月', new Date(singleDate)))
                break
              case 406:
                // 2019-1-1
                data.push(formatConverter.ConvertDateTime('yyyy-M-d', new Date(singleDate)))
                break
              case 407:
                // 2019/1/1
                data.push(formatConverter.ConvertDateTime('yyyy/M/d', new Date(singleDate)))
                break
              case 408:
                // 2019年1月1日
                data.push(formatConverter.ConvertDateTime('yyyy年M月d日', new Date(singleDate)))
                break
              case 413:
                // 1-1
                data.push(formatConverter.ConvertDateTime('M-d', new Date(singleDate)))
                break
              case 414:
                // 1/1
                data.push(formatConverter.ConvertDateTime('M/d', new Date(singleDate)))
                break
              case 415:
                // 1月1日
                data.push(formatConverter.ConvertDateTime('M月d日', new Date(singleDate)))
                break
              case 409:
                // 2019-1-1 1:01:01
                data.push(formatConverter.ConvertDateTime('yyyy-M-d h:mm:ss', new Date(singleDate)))
                break
              case 410:
                // 2019/1/1 1:01:01
                data.push(formatConverter.ConvertDateTime('yyyy/M/d h:mm:ss', new Date(singleDate)))
                break
              case 411:
                // 2019年1月1日 1时01分01秒
                data.push(formatConverter.ConvertDateTime('yyyy年M月d日 h时mm分ss秒', new Date(singleDate)))
                break
              case 416:
                // 1:01
                data.push(formatConverter.ConvertDateTime('h:mm', new Date(singleDate)))
                break
              case 417:
                // 1时01分
                data.push(formatConverter.ConvertDateTime('h时mm分', new Date(singleDate)))
                break
              case 418:
                // 1:01:01
                data.push(formatConverter.ConvertDateTime('h:mm:ss', new Date(singleDate)))
                break
              case 419:
                // 1时01分01秒
                data.push(formatConverter.ConvertDateTime('h时mm分ss秒', new Date(singleDate)))
                break
              default:
                data.push(formatConverter.ConvertDateTime('yyyy-M-d h:mm:ss', new Date(singleDate)))
                break
            }
          })
          if (cacheable) {
            cache[dropDownInfo.specId] = {
              params: JSON.stringify(params),
              value: data
            }
          }
          dropDownInfo.values = data
        } else {
          if (cacheable) {
            cache[dropDownInfo.specId].push({
              params: JSON.stringify(params),
              value: output.data
            })
          }
          dropDownInfo.values = output.data
        }
      } else {
        extendFunctions.errorMessage('id：' + dropDownInfo.specId + this.$t('report.dropDownError') + output.data)
      }
    },
    // 级联
    async initCascaderData(fieldId) {
      // 取参传参获取结果数据
      var handleCascader = this.currentDataSpec[0]
      this.cascaderOutput = null
      var params = {}
      params.param = this.GetParamWithFieldId(handleCascader.params, this.form)
      params.id = handleCascader.cascaderId
      params.fieldId = fieldId
      var cacheable = handleCascader.cache
      var cache = this.specCacheData.Cascader
      if (cacheable) {
        if (cache[handleCascader.cascaderId]) {
          console.time('查找缓存')
          var cacheValue = cache[handleCascader.cascaderId].find(item => item.params === JSON.stringify(params))
          if (cacheValue) {
            this.cascaderOutput = cacheValue.value
          }
          console.timeEnd('查找缓存')
        } else {
          cache[handleCascader.cascaderId] = []
        }
      }
      if (!this.cascaderOutput) {
        try {
          var cascaderOutput = await getCascaderSpecsOutput(params)
          if (cascaderOutput.status === 200) {
            this.cascaderOutput = cascaderOutput.data
            if (cacheable) {
              cache[handleCascader.cascaderId].push({
                params: JSON.stringify(params),
                value: cascaderOutput.data
              })
            }
          }
        } catch (exception) {
          extendFunctions.errorMessage(this.$t('report.cascadError'))
        }
      }
      console.time('构建')
      var result = this.handleCascaderData(fieldId, [])
      console.timeEnd('构建')
      this.cascaderData = result
      return result
    },
    handleCascaderData(fieldId, selections) {
      // 判断数据来源类型
      var nextLevelItems = []
      var data, i
      var handleCascader = this.currentDataSpec[0]
      var replaceAll = (str) => {
        if (typeof str === 'string') {
          return `'${str.replace(/'/g, "''")}'`
        } else {
          return str
        }
      }
      switch (handleCascader.sourceType) {
        case 0:
          // 列表
          // 当前选择数据所在的层级
          var currentLevel = selections.length
          // 当前选择数据所在层级的ID
          var currentLevelId = handleCascader.level2ColumnId[currentLevel]
          var cascaderQuery = `[${currentLevelId}] IS NOT NULL AND [${currentLevelId}] <> ''`
          selections.forEach((selectInfo, index) => {
            const handleLevelId = handleCascader.level2ColumnId[index]
            if (this.cascaderOutput.length && typeof this.cascaderOutput[0][handleLevelId] !== 'string') {
              try {
                selectInfo.value = parseFloat(selectInfo.value)
              } catch (ex) { console.error(ex) }
            }
            cascaderQuery += ` AND [${handleLevelId}]=${replaceAll(selectInfo.value)}`
          })
          // 获取层级数据
          var currentLevelData = alasql(`SELECT DISTINCT [${currentLevelId}] FROM ? WHERE ${cascaderQuery}`, [this.cascaderOutput])
          var currentLevelDataArr = []
          var maxLevel = handleCascader.columns.filter(columnInfo => { return (columnInfo.level >= 0 && columnInfo.level !== null) }).length - 1
          var canSelect, rowData
          currentLevelData.forEach(data => {
            var lastLevel = false
            var childDataCollection = alasql(`SELECT DISTINCT * FROM ? WHERE ${cascaderQuery} AND [${currentLevelId}]=${replaceAll(data[currentLevelId])}`, [this.cascaderOutput])
            canSelect = false
            // 判断自身是否可选
            for (var i = 0; i < childDataCollection.length; i++) {
              var compareData = ''
              for (var j = currentLevel + 1; j <= maxLevel; j++) {
                compareData += childDataCollection[i][handleCascader.level2ColumnId[j]]
              }
              if (!compareData) {
                canSelect = true
                rowData = childDataCollection[i]
                break
              }
            }
            if (childDataCollection.length === 1 && canSelect) {
              lastLevel = true
            }
            // 判断该节点是否可被选择
            currentLevelDataArr.push({
              label: data[currentLevelId],
              value: data[currentLevelId],
              lastLevel: lastLevel,
              canSelect: canSelect,
              rowData: rowData
            })
          })
          return currentLevelDataArr
        case 1:
          // 树形
          var parentColumnId = handleCascader.columns.filter(column => { return column.parent })[0].id
          var currentColumnId = handleCascader.columns.filter(column => { return column.child })[0].id
          var displayColumnId = handleCascader.columns.filter(column => { return column.show })[0].id
          data = this.cascaderOutput
          if (selections.length === 0) {
            var firstLevelItems = []
            data.filter(item1 => { return data.filter(item2 => { return item1[parentColumnId] === item2[currentColumnId] }).length === 0 }).forEach(row => {
              firstLevelItems.push({
                label: row[displayColumnId],
                value: row[currentColumnId],
                lastLevel: data.filter(item => { return item[parentColumnId] === row[currentColumnId] }).length === 0,
                canSelect: handleCascader.allowMiddle,
                rowData: row
              })
            })
            return firstLevelItems
          } else {
            var currentValue = selections.pop().value
            nextLevelItems = []
            // 为了解决类型对应问题，使用双等号，勿改动
            /*eslint eqeqeq: off*/
            data.filter(item => { return item[parentColumnId] == currentValue && item[parentColumnId] !== item[currentColumnId] }).forEach(row => {
              nextLevelItems.push({
                label: row[displayColumnId],
                value: row[currentColumnId],
                lastLevel: data.filter(item => { return item[parentColumnId] === row[currentColumnId] && row[parentColumnId] !== item[currentColumnId] }).length === 0,
                canSelect: handleCascader.allowMiddle,
                rowData: row
              })
            })
            return nextLevelItems
          }
        case 2:
          var splitField = handleCascader.columns.find(col => col.option)
          var labelField = handleCascader.columns.find(col => col.show)
          if (!splitField || !labelField) {
            extendFunctions.errorMessage('分级字段信息缺失！')
            return nextLevelItems
          }
          var splitInfo = JSON.parse(splitField.option).split.split(',')
          var sum
          sum = 0
          for (i = 0; i < splitInfo.length; i++) {
            splitInfo[i] = parseInt(splitInfo[i])
            sum += parseInt(splitInfo[i])
            splitInfo[i] = sum
          }
          i = selections.length
          data = i === 0 ? this.cascaderOutput.filter(row => row[splitField.id].length === splitInfo[0]) : this.cascaderOutput.filter(row => row[splitField.id].length === splitInfo[i] && row[splitField.id].substr(0, splitInfo[i - 1]) === selections[i - 1].value)
          data.forEach(row => {
            nextLevelItems.push({
              label: row[labelField.id],
              value: row[splitField.id],
              lastLevel: this.cascaderOutput.filter(row2 => row2[splitField.id].length === splitInfo[i + 1] && row2[splitField.id].substr(0, splitInfo[i]) === row[splitField.id]).length === 0,
              canSelect: true,
              rowData: row
            })
          })
          return nextLevelItems
      }
    },
    setRelativeValue(valList) {
      if (this.currentDataSpec.length && valList && valList.length) {
        const specInfo = this.currentDataSpec[0]
        const currentVal = valList[valList.length - 1]
        if (this.item.componentType === 'Cascader') {
          const childInfo = specInfo.columns.find(item => item.child)
          // const showInfo = specInfo.columns.find(item => item.show)
          const insertData = this.cascaderOutput.find(item => item[childInfo.id] === currentVal)
          if (specInfo.mapping) {
            for (var fieldId in specInfo.mapping) {
              this.$set(this.formData, fieldId, insertData[specInfo.mapping[fieldId]])
            }
          }
        }
      } else {
        this.$set(this.formData, this.item.id, null)
      }
    }
  }
}
